/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetCountryListResponseItems,
    GetCountryListResponseItemsFromJSON,
    GetCountryListResponseItemsFromJSONTyped,
    GetCountryListResponseItemsToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetCountryListResponse
 */
export interface GetCountryListResponse {
    /**
     * 
     * @type {Array<GetCountryListResponseItems>}
     * @memberof GetCountryListResponse
     */
    items: Array<GetCountryListResponseItems>;
}

export function GetCountryListResponseFromJSON(json: any): GetCountryListResponse {
    return GetCountryListResponseFromJSONTyped(json, false);
}

export function GetCountryListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCountryListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetCountryListResponseItemsFromJSON)),
    };
}

export function GetCountryListResponseToJSON(value?: GetCountryListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(GetCountryListResponseItemsToJSON)),
    };
}


